/**
 * Free-shipping progress meter.
 * Keeps every [data-free-ship] instance (cart drawer + cart page) in sync with
 * the live cart total. Listens to the theme's own cart:updated event and falls
 * back to a /cart.js fetch so it is correct on first paint after a cache hit.
 */
(function () {
  if (window.__freeShipBarInit) return;
  window.__freeShipBarInit = true;

  var SELECTOR = '[data-free-ship]';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function render(total) {
    var bars = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold || threshold <= 0) continue;

      var remaining = Math.max(threshold - total, 0);
      var pct = Math.min((total / threshold) * 100, 100);

      var fill = bar.querySelector('[data-free-ship-fill]');
      if (fill) fill.style.width = pct + '%';

      var msg = bar.querySelector('[data-free-ship-msg]');
      if (msg) {
        if (remaining === 0) {
          msg.textContent = bar.getAttribute('data-msg-success') || 'Free shipping unlocked';
        } else {
          var before = bar.getAttribute('data-msg-before') || '';
          var after = bar.getAttribute('data-msg-after') || '';
          msg.innerHTML = '';
          msg.appendChild(document.createTextNode(before));
          var strong = document.createElement('strong');
          strong.textContent = formatMoney(remaining);
          msg.appendChild(strong);
          msg.appendChild(document.createTextNode(after));
        }
      }

      bar.classList.toggle('free-ship--unlocked', remaining === 0);
    }
  }

  function refreshFromServer() {
    if (!document.querySelector(SELECTOR)) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) render(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) render(evt.detail.cart.total_price);
    else refreshFromServer();
  });

  // The drawer re-renders its contents on build; re-sync afterwards.
  document.addEventListener('cart:build', refreshFromServer);
  document.addEventListener('ajaxProduct:added', refreshFromServer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFromServer);
  } else {
    refreshFromServer();
  }
})();
